import { reset } from '@formkit/core'

export interface FormData {
  topic?: string
  [key: string]: string | undefined
}

export const useForm = (endpointUrl: string, formId?: string) => {
  // Reactive state for form values, error, and status
  const values: Ref<FormData> = ref({})
  const error = ref('')
  const status = ref()

  let scrollAfterDelay: NodeJS.Timeout | null = null

  // Handle the transition before entering an element (scrolling behavior)
  const transitionBeforeEnter = (el: HTMLElement) => {
    if (scrollAfterDelay) {
      clearTimeout(scrollAfterDelay)
    }
    scrollAfterDelay = setTimeout(() => {
      const top = el.offsetTop - 200
      window.scrollTo({
        top,
        behavior: 'smooth',
      })
    }, 100)
  }

  const { executeRecaptcha } = useGoogleRecaptcha()

  // Handle form submission
  const send = async (data: FormData) => {
    clearMessages() // Clear any previous messages
    try {
      const { token } = await executeRecaptcha('submit')
      data.token = token
      const res = await $fetch<{ status?: string }>(endpointUrl, {
        method: 'POST',
        body: data,
      })

      // Assuming you're using FormKit
      if (formId) {
        reset(formId)
      }
      status.value = res.status
    } catch (err) {
      error.value = err
      console.error(err)
    } finally {
      // ensure that even if an error occurs, we set a status
      status.value = status.value || 'error'
    }
  }

  // Clear messages (status, error)
  const clearMessages = () => {
    status.value = ''
    error.value = ''
  }

  return {
    values,
    error,
    status,
    transitionBeforeEnter,
    send,
    clearMessages,
  }
}
